import { useState, useEffect, useCallback } from 'react';
import notificationService from '../services/notificationService';
import { useAuth } from '../contexts/AuthContext';

const useUnreadNotifications = () => {
  const { user, isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCount = useCallback(async () => {
    if (!isAuthenticated || !user) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }
    
    try {
      setLoading(true);
      const response = await notificationService.getUnreadCount();
      setUnreadCount(response.unreadCount);
    } catch (error) {
      console.error('Hiba az olvasatlan értesítések számának lekérdezésekor:', error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  }, [user, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && user) {
      fetchUnreadCount();
      
      // Polling az olvasatlan értesítések számának frissítéséhez (30 másodpercenként)
      const pollIntervalId = notificationService.pollUnreadCount(
        (count) => setUnreadCount(count),
        30000
      );

      return () => {
        if (pollIntervalId) {
          clearInterval(pollIntervalId);
        }
      };
    } else {
      setUnreadCount(0);
      setLoading(false);
    }
  }, [user, isAuthenticated, fetchUnreadCount]);

  return { unreadCount, loading, refetch: fetchUnreadCount };
};

export default useUnreadNotifications;